/* */ 
"use strict";
var core_1 = require('@angular/core');
var compile_metadata_1 = require('./compile_metadata');
var o = require('./output/output_ast');
var shadow_css_1 = require('./shadow_css');
var url_resolver_1 = require('./url_resolver');
var style_url_resolver_1 = require('./style_url_resolver');
var lang_1 = require('./facade/lang');
var COMPONENT_VARIABLE = '%COMP%';
var HOST_ATTR = "_nghost-" + COMPONENT_VARIABLE;
var CONTENT_ATTR = "_ngcontent-" + COMPONENT_VARIABLE;
var StylesCompileDependency = (function() {
  function StylesCompileDependency(moduleUrl, isShimmed, valuePlaceholder) {
    this.moduleUrl = moduleUrl;
    this.isShimmed = isShimmed;
    this.valuePlaceholder = valuePlaceholder;
  }
  return StylesCompileDependency;
}());
exports.StylesCompileDependency = StylesCompileDependency;
var StylesCompileResult = (function() {
  function StylesCompileResult(statements, stylesVar, dependencies) {
    this.statements = statements;
    this.stylesVar = stylesVar;
    this.dependencies = dependencies;
  }
  return StylesCompileResult;
}());
exports.StylesCompileResult = StylesCompileResult;
var StyleCompiler = (function() {
  function StyleCompiler(_urlResolver) {
    this._urlResolver = _urlResolver;
    this._shadowCss = new shadow_css_1.ShadowCss();
  }
  StyleCompiler.prototype.compileComponent = function(comp) {
    var shim = comp.template.encapsulation === core_1.ViewEncapsulation.Emulated;
    return this._compileStyles(getStylesVarName(comp), comp.template.styles, comp.template.styleUrls, shim);
  };
  StyleCompiler.prototype.compileStylesheet = function(stylesheetUrl, cssText, isShimmed) {
    var styleWithImports = style_url_resolver_1.extractStyleUrls(this._urlResolver, stylesheetUrl, cssText);
    return this._compileStyles(getStylesVarName(null), [styleWithImports.style], styleWithImports.styleUrls, isShimmed);
  };
  StyleCompiler.prototype._compileStyles = function(stylesVar, plainStyles, absUrls, shim) {
    var _this = this;
    var styleExpressions = plainStyles.map(function(plainStyle) {
      return o.literal(_this._shimIfNeeded(plainStyle, shim));
    });
    var dependencies = [];
    for (var i = 0; i < absUrls.length; i++) {
      var identifier = new compile_metadata_1.CompileIdentifierMetadata({name: getStylesVarName(null)});
      dependencies.push(new StylesCompileDependency(absUrls[i], shim, identifier));
      styleExpressions.push(new o.ExternalExpr(identifier));
    }
    var stmt = o.variable(stylesVar).set(o.literalArr(styleExpressions, new o.ArrayType(o.DYNAMIC_TYPE, [o.TypeModifier.Const]))).toDeclStmt(null, [o.StmtModifier.Final]);
    return new StylesCompileResult([stmt], stylesVar, dependencies);
  };
  StyleCompiler.prototype._shimIfNeeded = function(style, shim) {
    return shim ? this._shadowCss.shimCssText(style, CONTENT_ATTR, HOST_ATTR) : style;
  };
  StyleCompiler.decorators = [{type: core_1.Injectable}];
  StyleCompiler.ctorParameters = [{type: url_resolver_1.UrlResolver}];
  return StyleCompiler;
}());
exports.StyleCompiler = StyleCompiler;
function getStylesVarName(component) {
  var result = "styles";
  if (lang_1.isPresent(component)) {
    result += "_" + component.type.name;
  }
  return result;
}
